import DynamicObject from "../../models/dynamic-object";
import { AxiosResponse} from "axios";
import Api from "../api";

export default (adId : number,config?: DynamicObject): Promise<AxiosResponse> => {
    const path = 'posts'
    return Api.getInstance().request.get(`${path}/${adId}?fields=id,members_id,country_abbr,first_image_thumb,title&expand=searchMember`, path)
}